import { type IHydratedWidget } from '../../../../../hydrate/IHydrationContext.ts';
import { generateMarginStyle } from '../../../../directives/margin/generateMarginStyle.ts';
import { type IHtmlRenderContext } from '../../../IWidgetType.ts';
import { type IParagraphWidget } from './IParagraphWidget.ts';

export function renderParagraphHtml(
  widget: IHydratedWidget<IParagraphWidget>,
  _context: IHtmlRenderContext,
): string {
  const marginStyle = generateMarginStyle(widget.directives?.margin);

  const html = widget.body
    ?.filter(item => item.text)
    .map(item => item.text)
    .join('');

  if (!html) return '';
  const styleParagraph = marginStyle ? ` style="${marginStyle}"` : '';

  return `<div${styleParagraph}>${html}</div>`;
}
